module.exports = __webpack_public_path__ + "static/media/flute.1454f680.svg";